/**
 * 2007-2019 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/afl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */

import "./front.scss";

let ljd_selfPromoBlocks_nbOfPages = 0;
let ljd_selfPromoBlocks_pageNum = 1;

const processAjaxLoad = ($products) => {
	// On vérifie si on a un block d'autopromo
	var paginationLinks = document.querySelectorAll('.pagination ul.page-list li');
	if (paginationLinks) {
		ljd_selfPromoBlocks_nbOfPages = paginationLinks.length - 1;
	}
	ljd_selfPromoBlocks_pageNum++;
	const selfpromoblock = document.querySelector(".products .selfpromoblock");
	if (selfpromoblock) {
		// Si oui on compte les produits actuellements présents dans la page
		const pageProducts = document.querySelectorAll(".products article.product-miniature");
		// On récupère le nombre de produits par page configuré via l'admin
		const resultsPerPage = document.querySelector('#js-product-list').getAttribute('data-results-per-page');
		let hiddenProducts = 0;

		if (pageProducts.length >= resultsPerPage) {
			// On parcours les produits et s'ils ont la classe 'ljd_hide_product' on la retire pour les afficher
			pageProducts.forEach((p) => {
				if (p.classList.contains('ljd_hide_product')) {
					p.classList.remove('ljd_hide_product');
					hiddenProducts++;
				}
			});
			// Si le nombre de produits à afficher + les produits cachés > au nombre de produits par page, on cache l'excédent
			// Sauf si c'est la dernière page à charger
			if (ljd_selfPromoBlocks_pageNum < ljd_selfPromoBlocks_nbOfPages && $products.length + hiddenProducts > resultsPerPage) {
				const nbProductsToHide = $products.length + hiddenProducts - resultsPerPage;
				const startIdx = $products.length - nbProductsToHide;
				for(let i = startIdx; i < startIdx + nbProductsToHide; i++) {
					$products[i].classList.add('ljd_hide_product');
				}
			}
		}
	}
};

export { processAjaxLoad };
